import { Column } from 'react-table';
import { useTheme } from '@mui/material';
import { StatusIndicator } from 'redesign';
import { useTranslation } from 'react-i18next';
import {
  PartnerPlannerTableCellProp,
  PartnerPlannerTableDefinition,
} from './partner-planner-modal-table.types';
import { getPlannerModalTableDefinition } from './use-get-planner-modal-table-definition';
import { useAvailabilityStatusAndColor } from '../../../../../../../shared/components/flex-workers-for-work-table/utils/helpers';

export const useGetPlannerWorkerTableColumnDefinition =
  (): Column<PartnerPlannerTableDefinition>[] => {
    const { t } = useTranslation('hq-screen-specific');
    const [worker, email, phone, certificate, actions] = getPlannerModalTableDefinition(t);

    const availability: Column<PartnerPlannerTableDefinition> = {
      Header: t('shifts.candidates.table_headers.availability', { ns: 'hq-screen-specific' }),
      accessor: 'availability',
      Cell: AvailabilityCell,
      width: '180px',
    };

    return [worker, email, phone, certificate, availability, actions];
  };

const AvailabilityCell = (cell: PartnerPlannerTableCellProp<'availability'>) => {
  const theme = useTheme();
  const { availability, color } = useAvailabilityStatusAndColor(cell.value);
  return (
    <StatusIndicator
      backgroundColor={color}
      label={availability}
      color={theme.palette.lwBlack[100]}
    />
  );
};
